/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from '@angular/core';
import { IMaskFactory } from 'angular-imask';

@Injectable()
export class MockIMaskFactory implements IMaskFactory {
  create(el: any, opts: any): any {
    return new MockedInputMask();
  }
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

export class MockedInputMask {
  on(ev: string, handler: any): this {
    return this;
  }
  off(ev: string, handler?: any): this {
    return this;
  }
  updateOptions() {
    return noop;
  }
  destroy() {
    return noop;
  }
  value() {
    return noop;
  }
  unmaskedValue() {
    return noop;
  }
  typedValue() {
    return noop;
  }
}
